import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Table, Icon, Spin } from 'antd';
import moment from 'moment';
import { Modal } from '../../../../helpers/commonUi'
import nodataImg from "../../../../assets/images/createDelpoyIcon.svg";
import vulnerabilitiesImg from "../../../../assets/images/vulnerabilities.svg";
import inProgressSvg from "../../../../assets/images/inProgress.svg";
import errorSvg from "../../../../assets/images/error.svg";
import arrowRight from "../../../../assets/images/arrow-right.svg";
import style from './list.module.sass';
import NewVersion from './NewVersion';
import Deployment from './Deployment';
import History from './History';
import { Http } from '../../../../helpers/axois';
import { DeploymentUpdateVerison } from '../../../../helpers/RxServices';
import { Button } from '../../../../helpers/commonUi';
import classNames from 'classnames';
import { useToast } from "../../../../helpers/commonFunction";
import NoData from '../../NoData'
import { useDispatch, useSelector } from 'react-redux';
import LiveDeployment from './LiveDeployment';
import { DmnDeployModal } from './DmnDeployModal';
import { setStepIndex } from '../../../../stateManager/store/onboarding/action';
import { AppState } from '../../../../stateManager/store';
import ModalFooter from '../../../../helpers/commonUi/ModalFooter';
import { updateOnboarding } from '../../../../helpers/onboardingHelper';
import SearchBar, { highlightMatch } from "../../../../helpers/SearchBar";
import { useHistory } from 'react-router-dom';
interface Props {
    appDetails?: any;
}
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const List: React.FC<Props> = (props) => {
    const appDetails = props.appDetails && props.appDetails[0];
    const appId = appDetails && appDetails.appId
    const [loading, SetLoading] = useState(true);
    const navigate = useHistory();
    const [list, setlist] = useState([]); //  previous version data
    const [modalVisible, setmodalVisible] = useState(false); // create new version modal
    const [deployModal, setdeployModal] = useState(false);  // open deploy modal
    const [version, setversion] = useState<any>({});  // save create new version from version modal
    const [deployData, setdeployData] = useState<any>({}); // save deploy data from modal
    const [livedeployData, setlivedeployData] = useState<any>({}); // save deploy data from modal
    const [historymodal, sethistorymodal] = useState(false) // open histroy modal
    const [liveDeploymodal, setliveDeploymodal] = useState(false) // open live deploy modal
    const [currentDeployTable, setcurrentDeployTable] = useState<any>(); /// current  deploy data from table row
    const [envList, setEnvList] = useState<any>([])
    const [error, setError] = useState<any>();
    const [isFormSelected, setIsFormSelected] = useState<boolean>(true);
    const [dmnDeploy, setDmnDeploy] = useState<boolean>(false)
    const [showDmnDeployModal, setShowDmnDeployModal] = useState<boolean>(false)
    const { ErrorToast, SuccessToast } = useToast();
    const [deployment, setDeployment] = useState("")
    const [deploymentLoading, setDeploymentLoading] = useState(false)
    const [filteredData, setFilterData] = useState<any[]>([])
    const searchRef = useRef<{ clearSearch: () => void }>(null);
    const [searchValue, setSearchValue] = useState<string>("")
    const [vulnerabilities, setVulnerabilities] = useState<{status: "PASSED" | "FAILED" | "IN_PROGRESS" | "ERROR", count: number}>({status: "PASSED", count: 0})
    const capabilities = useSelector((state: any) => state.user.userDetails.capabilities)
    const appInfo = useSelector((state: any) => state.apps.selectedApp)
    const orgId = useSelector((state: any) => state.org.selectedOrg.id)
    const {guideVisible, info: onboardingInfo} = useSelector((state: AppState) => state.onboarding)
    const userName = useSelector((state: AppState) => state.user.data.user.userName)
    const [showProdConfirmationModal,setShowProdConfirmationModal]=useState(false)
    const appType = appInfo.type

    const dispatch = useDispatch();

    useEffect(() => {
        Http.get(`org/${orgId}/environments`).subscribe((res: any) => {
            setEnvList(res);
        })
    }, [orgId, appType])

    const currentAppBranch = useSelector((state: any) => {
        const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
        return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
    }, (left: any, right: any) => left.branchId === right.branchId)

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const appPermissions: any = useSelector((state: any) => {
        return state.apps.selectedApp.permissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const canCreateRelease = orgPermissions.includes('deploy.CreateRelease') || appPermissions.includes('deploy.CreateRelease')
    const canLiveDeploy = orgPermissions.includes('deploy.LiveDeploy') || appPermissions.includes('deploy.LiveDeploy')
    const canDeploy = orgPermissions.includes('deploy.Deploy') || appPermissions.includes('deploy.Deploy')

    const getVersion = useCallback(() => {
        searchRef.current?.clearSearch()
        const branchId = currentAppBranch && currentAppBranch.branchId
        if (appId) {
            Http.get(`version/${appId}?branchId=${branchId}`).subscribe((versionList: any) => {
                setlist(versionList)
                setFilterData(versionList)
                SetLoading(false);
            }, (err) => {
                setFilterData([])
                SetLoading(false);
            })
        }
    }, [appId, currentAppBranch])

    useEffect(() => {
        getVersion();
        SetLoading(true);
    }, [getVersion])

    useEffect(() => {
        if (!isFormSelected) {
            ErrorToast('Please select the reference to form or service')
        }
    }, [ErrorToast, isFormSelected])

    const createNewVersion = () => {
        const branchId = currentAppBranch && currentAppBranch.branchId
        setError(null);
        if (appInfo && appType === 'a8flow' && !version.bpmnId) {
            ErrorToast('Please select a Journey')
            return 0;
        }
        if (!version.versionTag) {
            ErrorToast('Please enter the versionTag')
            return 0;
        }
        if (!appDetails) {
            return 0;
        }
        setDeploymentLoading(true);
        const data = {
            ...version,
            cVersionTag: appDetails.versionTag,
            cVersionCode: appDetails.versionCode,
            branchId: branchId
        }
        Http.post(`version/${appDetails.appId}`, data).subscribe((res) => {
            SuccessToast('Version created successfully')
            getVersion();
            DeploymentUpdateVerison.sendMessage({
                message: 'versionCreated',
                data: {}
            });
            if (guideVisible) {
                const stepIndex = onboardingInfo.stepIndex;
                dispatch(setStepIndex(stepIndex + 1));
                updateOnboarding(userName, {...onboardingInfo, stepIndex: stepIndex + 1})
            }
            setmodalVisible(false);
            setDeploymentLoading(false)
        }, (err) => {
            if (err && err.message) {
                ErrorToast(err.message.replace("Bpmn", "Journey"))
            } else {
                ErrorToast('Version creation failed')
            }
            setError(err);
            setDeploymentLoading(false)
        })
    }

    const deploy = (isDmnDeploy = false) => {
        if (!deployData.envId && !capabilities) {
            ErrorToast('Please select the environment')
            return 0;
        }
        setDeploymentLoading(true)
        const data = {
            ...deployData,
            appId: appDetails.appId,
            versionId: currentDeployTable.version_id,
            isDmnDeploy: isDmnDeploy,
            genaiUrl: window.env?.GENAI_URL,
        }
        Http.post('deployment', data).subscribe((res: any) => {
            SuccessToast('Deployment successful')
            getVersion()
            setdeployModal(false);
            if (guideVisible) {
                const stepIndex = onboardingInfo.stepIndex;
                dispatch(setStepIndex(stepIndex + 1));
                updateOnboarding(userName, {...onboardingInfo, stepIndex: stepIndex + 1})
            } 
            setcurrentDeployTable(null);
            setShowDmnDeployModal(false);
            setdeployData({});
            setDeployment("")
            setDmnDeploy(false)
            setDeploymentLoading(false)
            setShowProdConfirmationModal(false)
        }, (err) => {
            if (err && err.message) {
                ErrorToast(err.message.replace("bpmn", "Journey"), false)
            } else {
                ErrorToast('Deployment failed')
            }
            setdeployModal(false);
            setShowDmnDeployModal(false);
            setcurrentDeployTable(null);
            setdeployData({});
            setDeployment("")
            setDmnDeploy(false)
            setDeploymentLoading(false)
            setShowProdConfirmationModal(false)
        });
    }

    const liveDeploy = (dmnDeploy = false) => {
        if (!livedeployData.envId && !capabilities) {
            ErrorToast('Please select the environment')
            return 0;
        }
        setDeploymentLoading(true)
        const data = {
            ...livedeployData,
            appId: appDetails.appId,
            'versionTag': appDetails.versionTag,
            'versionId': appDetails.version_id,
            'host': window.location.origin,
            isDmnDeploy: dmnDeploy,
            genaiUrl: window.env?.GENAI_URL,
        }
        Http.post('livedeployment', data).subscribe((res: any) => {
            SuccessToast('Deployment successful')
            setliveDeploymodal(false);
            setShowDmnDeployModal(false);
            setlivedeployData({});
            setDeployment("")
            setDmnDeploy(false)
            setDeploymentLoading(false)
            setShowProdConfirmationModal(false)
        }, (err) => {
            if (err && err.message) {
                ErrorToast(err.message.replace("bpmn", "Journey"))
            } else {
                ErrorToast('Deployment failed')
            }
            setliveDeploymodal(false);
            setShowDmnDeployModal(false);
            setlivedeployData({});
            setDeployment("")
            setDmnDeploy(false)
            setDeploymentLoading(false)
            setShowProdConfirmationModal(false)
        })
    }

    const columns = [
        {
            title: 'Version Code',
            dataIndex: 'version_code',
            key: 'vc',
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return <span data-test-id="version_code" >{formattedValue}</span>
            }
        },
        {
            title: 'Version Tag',
            dataIndex: 'version_tag',
            key: 'vt',
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return <span data-test-id="version_tag" >{formattedValue}</span>
            }
        },
        {
            title: 'Release Notes',
            dataIndex: 'release_note',
            key: 'rn',
            render: (value: string)=>{
                const formattedValue = highlightMatch(value, searchValue)
                return <span data-test-id="release_notes" >{formattedValue}</span>
            }
        },
        {
            title: 'Recently Deployed',
            dataIndex: 'envType',
            key: 'rd',
            render: (text: any, record: any) => {
                const formattedValue = record?.deploy?.envType ? highlightMatch(record?.deploy?.envType.toUpperCase(), searchValue) : null
                return (
                    (record.deploy && record.deploy.envType) ? (
                        <div data-test-id="recently_deployed" className={style.recDeploy}>
                            <div className={classNames({
                                [style.depStatusStag]: (record.deploy.envType === 'staging'),
                                [style.depStatusTesting]: (record.deploy.envType === 'testing'),
                                [style.depStatusProd]: (record.deploy.envType === 'production'),
                            })}>
                                {formattedValue}
                            </div>
                        </div>
                    ) : null
                )
            },
        },
        {
            title: 'Deployed Time',
            dataIndex: 'deployedTime',
            key: 'deployedtime',
            render: (text: any, record: any) => {
                const formattedValue = record?.deploy?.deployedTime && highlightMatch(moment.utc(record?.deploy?.deployedTime).fromNow(), searchValue)
                return (
                    <span data-test-id="deployed_time">{formattedValue}</span>
                )
            }
        },
        {
            title: 'Deployed By',
            dataIndex: 'depolyedBy',
            key: 'depolyedby',
            render: (text: any, record: any) => {
                const formattedValue = record?.deploy?.depolyedBy ? highlightMatch(record.deploy.depolyedBy, searchValue) : ""
                return (
                    <span data-test-id="deployed_time">{formattedValue}</span>
                )
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'button',
            render: (text: any, record: any) => canDeploy ?
                <div data-test-id="deploy_button" className={`create_deploy ${style.deployButton}`} onClick={(e: any) => {
                    e.stopPropagation();
                    if (envList.length > 0 || capabilities) {
                        setcurrentDeployTable(record);
                        setdeployModal(true)
                        if (guideVisible) {
                            dispatch(setStepIndex(onboardingInfo.stepIndex + 1))
                        }
                        setDeployment("version")
                    } else {
                        ErrorToast('No environments available to deploy')
                    }
                }}>
                    DEPLOY
                </div> : null,
        }
    ]

    const createRelease = () => {
        setmodalVisible(true)
        if (guideVisible) {
            dispatch(setStepIndex(onboardingInfo.stepIndex + 1))
        }
    }


    return (
        <div className='viewWrapper'>
            {
                (!loading && list.length > 0) ?
                    <React.Fragment>
                        <div className={"row " + style.versionButtons}>
                            {
                                canCreateRelease && <Button className={"tour_create_release"} dataTestId="create_release" onClick={createRelease} size='small' color='primary'>Create Release</Button>
                            }
                            <div className='flex gap-2 items-center'>
                                <SearchBar
                                    ref={searchRef}
                                    data={list}
                                    columns={columns}
                                    onFilter={(filteredData ) => {
                                        setFilterData(filteredData)
                                    }}
                                    onSearchTermChange={ (searchValue: string)=>{ setSearchValue(searchValue) } }
                                />
                                {
                                    canLiveDeploy && <Button dataTestId="live_deploy" size='small' onClick={() => { setliveDeploymodal(true); setDeployment("live") }} color='primary' className={`${style.liveDeploy} create_release_live`} style={{background: "FA741233", boxShadow: "none"}}>Live Deploy</Button>
                                }
                            </div>
                        </div>
                        {/* <div className={"row " + style.box} >
                            <div className={style.main}>
                                <div className={style.textDiv}>
                                    <span className={style.header}> Version code</span>
                                    <span className={style.subheader}> {appDetails && appDetails.versionCode} </span>
                                </div>
                                <div className={style.textDiv}>
                                    <span className={style.header}> Version Tag</span>
                                    <span className={style.subheader}> {appDetails && appDetails.versionTag} </span>
                                </div>
                            </div>
                            <div className={style.main}>
                                <Button onClick={() => setmodalVisible(true)} size='small' color='primary'>CREATE NEW VERSION</Button>
                            </div>
                        </div>
                        <div className={style.Table}>
                            <h4 className={style.preheader}>Live Version</h4>
                            <div className={"row " + style.box} >
                                <div className={style.main}>
                                    <div className={style.textDiv}>
                                        <span className={style.header}> Version code</span>
                                        <span className={style.subheader}> {appDetails && appDetails.versionCode} </span>
                                    </div>
                                    <div className={style.textDiv}>
                                        <span className={style.header}> Version Tag</span>
                                        <span className={style.subheader}> {appDetails && appDetails.versionTag} </span>
                                    </div>
                                </div>
                                <div className={style.main}>
                                    <Button size='small' onClick={() => setliveDeploymodal(true)} color='primary' className={style.liveDeploy}>Deploy</Button>
                                </div>
                            </div>
                        </div> */}
                        <div className={"row " + style.Table}>
                            <h4 className={style.preheader}>Versions</h4>
                            <Table data-test-id="table_row" rowKey="version_id" columns={columns}
                                pagination={false}
                                // rowSelection={{ 
                                //   type : 'checkbox',
                                //   onChange: (selectedRowKeys, selectedRows) => {
                                //   }
                                // }}
                                // scroll={{ y: 300 }}
                                scroll={{ y: 'calc(100vh - 240px)' }}
                                onRow={(record, rowIndex) => {
                                    return {
                                        'data-test-id': 'deployment_table_row_' + record.key,
                                        onClick: (e) => {
                                            setcurrentDeployTable(record);
                                            sethistorymodal(true);
                                        }
                                    }
                                }}
                                className={"override-table-container"} style={{ width: '100%' }} dataSource={filteredData} />
                        </div>
                    </React.Fragment>
                    :
                    (loading)
                        ?
                        <div className={style.loadingSpinner + " row"}>
                            <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                        </div>
                        :
                        <NoData
                            data-test-id="btn"
                            image={nodataImg}
                            header='Create Deployment'
                            content='Create deployment for your apps'
                            buttonClassName='tour_create_release'
                            // buttonText='Create new version'
                            buttonCallback={() => {
                                if (canCreateRelease) {
                                    setmodalVisible(true)
                                    if (guideVisible) {
                                        dispatch(setStepIndex(onboardingInfo.stepIndex + 1))
                                    }
                                } else {
                                    ErrorToast('You are not authorized to create deployment versions')
                                }
                            }}
                        />
            }
            <Modal
                dataTestId="cnv"
                id='cnv'
                title='CREATE NEW VERSION'
                visible={modalVisible}
                onCancel={() => {
                    setError(null);
                    setmodalVisible(false)
                }}
                unmountOnCancel={true}
                loading={deploymentLoading}
                footer={{
                    enable: false,
                }}
            // mode='EditCreate'
            >
               <>
               {
                    modalVisible &&
                    <NewVersion
                        data-test-id="new_version"
                        error={error}
                        setIsFormSelected={setIsFormSelected}
                        appDetails={appDetails} data={(key: any, value: any) => {
                            setError(null); setversion({
                                ...version,
                                [key]: value
                            })
                        }} />
                }
                <ModalFooter cancelCallback={()=> { setError(null); setmodalVisible(false)}} okClassName='modal_footer_loading tour_create_new_release' disableOkButton={deploymentLoading || !isFormSelected} okText='CREATE' cancelText='CANCEL' okCallback={createNewVersion} />
               </>
            </Modal>
            <Modal
                id='deployemnthistory'
                dataTestId="deployment_history"
                title='DEPLOYMENT HISTORY'
                visible={historymodal}
                onCancel={() => {
                    setcurrentDeployTable(null);
                    sethistorymodal(false)
                }}
                width='600px'
                unmountOnCancel={true}
                footer={{
                    enable: false
                }}
            // mode='EditCreate'
            >
                {historymodal && currentDeployTable && <History currentDeploy={{ ...currentDeployTable, orgId: appDetails.orgId }} />}
            </Modal>
            <Modal
                id="livedeploy"
                dataTestId="live_deploy"
                title={"Live Deployment"}
                visible={liveDeploymodal}
                onCancel={() => {
                    setliveDeploymodal(false);
                    setlivedeployData({});
                    setDmnDeploy(false);
                }}
                loading={deploymentLoading}
                unmountOnCancel={true}
                footer={{
                    enable: true,
                    okText: 'DEPLOY',
                    cancelText: "CANCEL",
                    disableOkButtonClass: "modal_footer_loading",
                    onOk: () => {
                        if (!capabilities){
                            if (!dmnDeploy) {
                                const env = envList.find((e: any) => e?.id === livedeployData?.envId);
                                if (env?.type === "production") {
                                    setliveDeploymodal(false)
                                    setShowProdConfirmationModal(true)
                                    return
                                }
                                liveDeploy()
                            }
                            else if (livedeployData?.envId) {
                                setliveDeploymodal(false);
                                setShowDmnDeployModal(true);
                            } else if (!livedeployData?.envId) {
                                ErrorToast('Please select the environment')
                                setDeploymentLoading(false)
                            }
                        } else if ((livedeployData?.bpmnId || livedeployData?.id) && capabilities){
                            if(!dmnDeploy){
                                liveDeploy()
                            }else{
                                setliveDeploymodal(false);
                                setShowDmnDeployModal(true);
                            }
                        }
                    },
                    disableOkButton: !isFormSelected
                }}
            >
                {liveDeploymodal && <LiveDeployment capabilities={capabilities} envList={envList} setIsFormSelected={setIsFormSelected} data={(key: any, value: any) => setlivedeployData({
                    ...livedeployData,
                    [key]: value
                })} currentDeploy={{ orgId: appDetails.orgId }} setDmnDeploy={setDmnDeploy} dmnDeploy={dmnDeploy} appDetails={appDetails}></LiveDeployment>}
            </Modal>
            <Modal
                id="dmnDeploy"
                dataTestId="dmn_deploy"
                title="Confirmation"
                visible={showDmnDeployModal}
                onCancel={() => {
                    setShowDmnDeployModal(false);
                    setDmnDeploy(false);
                    setDeployment("")
                }}
                unmountOnCancel={true}
                loading={deploymentLoading}
                footer={{
                    enable: true,
                    okText: 'Yes',
                    cancelText: "No",
                    onOk: () => {
                        const env = envList.find((e: any) => e?.id === deployData?.envId || e?.id === livedeployData?.envId  );
                        if (env?.type === "production") {
                            setShowDmnDeployModal(false)
                            setShowProdConfirmationModal(true)
                        } else if (deployment === "live") {
                                    liveDeploy(true)
                                } else if (deployment === "version") {
                                    deploy(true)
                                }
                    },
                    disableOkButton: !isFormSelected,
                    disableOkButtonClass: "modal_footer_loading"
                }}
            >
                <DmnDeployModal appDetails={appDetails} />
            </Modal>
            <Modal
                id='deploy'
                dataTestId="deploy"
                title='DEPLOYMENT'
                visible={deployModal}
                onCancel={() => {
                    setcurrentDeployTable(null);
                    setdeployModal(false)
                }}
                loading={deploymentLoading}
                unmountOnCancel={true}
                footer={{
                    enable: false,
                }}
            // mode='EditCreate'
            >
               <>
                    {
                        currentDeployTable && <Deployment
                            capabilities={capabilities}
                            envList={envList}
                            currentDeploy={{ ...currentDeployTable, orgId: appDetails.orgId }}
                            data={(key: any, value: any) => setdeployData({
                                ...deployData,
                                [key]: value
                            })}
                            dmnDeploy={dmnDeploy}
                            setDmnDeploy={setDmnDeploy}
                        />
                    }
                    <ModalFooter 
                        okCallback={() => {
                            if(!capabilities){
                                if (!dmnDeploy) {
                                    const env = envList.find((e: any) => e?.id === deployData?.envId);
                                    if (env?.type === "production") {
                                        setdeployModal(false)
                                        setShowProdConfirmationModal(true)
                                        return
                                    }
                                    deploy()
                                }
                                else if (deployData?.envId) {
                                    setdeployModal(false);
                                    setShowDmnDeployModal(true);
                                } else if (!deployData?.envId) {
                                    ErrorToast('Please select the environment')
                                    setDeploymentLoading(false);
                                }
                            }else if(capabilities){
                                if(!dmnDeploy){
                                    deploy()
                                }else{
                                    setdeployModal(false);
                                    setShowDmnDeployModal(true);
                                }
                            }
                        }} 
                        cancelCallback={()=> { setcurrentDeployTable(null); setdeployModal(false); setlivedeployData({}); setDmnDeploy(false); }} 
                        okClassName='modal_footer_loading' 
                        okText='DEPLOY' 
                        cancelText="CANCEL" 
                        disableOkButton= {deploymentLoading}
                    />
               </>
            </Modal>
            <Modal
                id='deploy_confirmation'
                dataTestId="deploy_confirmation"
                title='CONFIRM DEPLOYMENT'
                visible={showProdConfirmationModal}
                onCancel={() => {
                    setShowProdConfirmationModal(false);
                    setcurrentDeployTable(null);
                    setDeployment("");
                }}
                loading={deploymentLoading}
                unmountOnCancel={true}
                footer={{
                    enable: false,
                }}
            >
                <>
                    <div style={{padding:"16px 35px 40px 14px",fontSize:16,color:"#292D32"}}>You are about to deploy to production. 
                    <div> <span style={{fontWeight:600}}>Caution: </span>This action cannot be undone. Continue?</div> </div>
                    <ModalFooter
                        okCallback={() => {
                                if (deployment === "live") {
                                    liveDeploy(dmnDeploy)
                                } else if (deployment === "version") {
                                    deploy(dmnDeploy)
                                }
                           
                        }}
                        cancelCallback={() => { setShowProdConfirmationModal(false);setcurrentDeployTable(null); setdeployModal(false) }}
                        okClassName='modal_footer_loading'
                        okText='CONFIRM'
                        cancelText="CANCEL"
                        disableOkButton={deploymentLoading}
                    />
                </>
            </Modal>
        </div>
    );
}

export default List;
